import { ConfigProvider, App as AntdApp } from 'antd'
import { ThemeProvider } from 'antd-style'

import { antdConfig } from './config/antd'
import { ContractDesigner } from './designer/Index'

export const App = () => {
  return (
    <ThemeProvider>
      <ConfigProvider {...antdConfig}>
        <AntdApp>
          <ContractDesigner />
        </AntdApp>
      </ConfigProvider>
    </ThemeProvider>
  )
}
